import React from 'react'
import LazyLoad from 'react-lazyload'
import { DefaultLayout } from '../../layouts'
import {
  Hero,
  // Banner,
  SectionMap,
  SectionEvent,
  SectionResources,
  // SectionCta,
  SectionBlog,
  SectionStoryMap,
  SectionNewsletter
} from './components'

const Home = () => {
  return (
    <div style={{background: '#f5f5f5'}}>
      <DefaultLayout>
        <LazyLoad height={'100vh'}>
          <Hero />
          {/* <Banner /> */}
          <SectionMap />
        </LazyLoad>
        <SectionResources />
        <LazyLoad>
          <SectionStoryMap />
        </LazyLoad>
        <SectionEvent />
        <SectionBlog />
        <LazyLoad>
          <SectionNewsletter />
        </LazyLoad>
        {/* <SectionCta /> */}
      </DefaultLayout>
    </div>
  )
}

export { Home }
